import { useEffect } from 'react'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

import { useLenis, useLenisStore } from '@/contexts/lenis'
import { useRouterStore } from '@/store/router'

const headerContainedClassName = 'header-contained'
const headerCollapsedClassName = 'header-collapsed'

const LayoutController = () => {
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!lenis) return

      const scrollTrigger = ScrollTrigger.create({
        start: () => window.innerHeight - (window.innerWidth < 768 ? 85 : 170), // header height
        end: () => ScrollTrigger.maxScroll(document.documentElement) + 1,
        toggleClass: {
          targets: document.documentElement,
          className: headerContainedClassName
        }
      })

      return () => {
        scrollTrigger.kill()
      }
    },
    { dependencies: [lenis] }
  )

  useEffect(() => {
    const unsubscribe = useLenisStore.subscribe(
      (state) => [state.scroll, state.direction],
      // eslint-disable-next-line no-unused-vars
      ([scroll, direction], [prevScroll, prevDirection]) => {
        if (!direction || direction === prevDirection) return
        direction > 0
          ? document.documentElement.classList.add(headerCollapsedClassName)
          : document.documentElement.classList.remove(headerCollapsedClassName)
      }
    )

    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    const unsubscribe = useRouterStore.subscribe(
      (state) => state.currentRoute,
      () => document.documentElement.classList.remove(headerCollapsedClassName)
    )

    return () => {
      unsubscribe()
    }
  }, [])

  return null
}

export default LayoutController
